export enum OfferType {
  UPSELL = 'UPSELL',
  TRIAL_CREDITS = 'TRIAL_CREDITS',
}
